import React from 'react'
import cls from './chosenFilter.module.sass'
import { useTranslation } from 'react-i18next'

interface Props {
    filter: string
    onClick: () => void
}

const ChosenFilter = (props: Props) => {
    const { filter, onClick } = props
    const [t] = useTranslation()
    return (
        <div className={cls['chosenFilterWrapper']} onClick={onClick}>
            {t(filter)}
        </div>
    )
}

export default ChosenFilter
